import Rubrics from './rubrics.js';

const rubric = new Rubrics();

export default {
    'TemplateRubrics/EDIT': {
        fields: ['title'],
        callback: async (store, mutation) => {
            await rubric.save(store, mutation);
        },
    },

    'TemplateRubrics/PUSH_RATING': {
        fields: ['criteria_ratings'],
        callback: async (store, mutation) => {
            await rubric.pushRating(store, mutation);
        },
    },

    'TemplateRubrics/SET_CRITERIA': {
        fields: ['title', 'description', 'max_value'],
        callback: async (store, mutation) => {
            await rubric.setCriteria(store, mutation);
        },
    },

    'TemplateRubrics/SET_RATING': {
        fields: ['description', 'value'],
        callback: async (store, mutation) => {
            await rubric.setRating(store, mutation);
        },
    },

    'TemplateRubrics/REMOVE_CRITERIA': {
        fields: 'criterias',
        callback: async (store, mutation) => {
            await rubric.removeCriteria(store, mutation);
        },
    },

    'TemplateRubrics/REMOVE_RATING': {
        fields: 'criteria_ratings',
        callback: async (store, mutation) => {
            await rubric.removeRating(store, mutation);
        },
    },

    'TemplateRubrics/REORDER': {
        fields: 'reorder',
        callback: async (store, mutation) => {
            await rubric.save(store, mutation);
        },
    },

    'TemplateRubrics/DELETE': {
        fields: 'delete',
        callback: async (store, mutation) => {
            await rubric.delete(store, mutation);
        },
    },

    'Rubrics/EDIT': {
        fields: ['title'],
        callback: async (store, mutation) => {
            await rubric.save(store, mutation);
        },
    },

    'Rubrics/PUSH_RATING': {
        fields: ['criteria_ratings'],
        callback: async (store, mutation) => {
            await rubric.pushRating(store, mutation);
        },
    },

    'Rubrics/SET_CRITERIA': {
        fields: ['title', 'description', 'max_value'],
        callback: async (store, mutation) => {
            await rubric.setCriteria(store, mutation);
        },
    },

    'Rubrics/SET_RATING': {
        fields: ['description', 'value'],
        callback: async (store, mutation) => {
            await rubric.setRating(store, mutation);
        },
    },

    'Rubrics/REMOVE_CRITERIA': {
        fields: 'criterias',
        callback: async (store, mutation) => {
            await rubric.removeCriteria(store, mutation);
        },
    },

    'Rubrics/REORDER': {
        fields: 'reorder',
        callback: async (store, mutation) => {
            await rubric.save(store, mutation);
        },
    },

    'Rubrics/REMOVE_RATING': {
        fields: 'criteria_ratings',
        callback: async (store, mutation) => {
            await rubric.removeRating(store, mutation);
        },
    },

    'Rubrics/DELETE': {
        fields: 'delete',
        callback: async (store, mutation) => {
            await rubric.delete(store, mutation);
        },
    },
};
